document.addEventListener('DOMContentLoaded', function () {
  var toggle = document.querySelector('.gpsr-toggle');
  var content = document.querySelector('.gpsr-content');
  if (!toggle || !content) return;
  toggle.addEventListener('click', function () {
    toggle.classList.toggle('open');
    content.classList.toggle('open');
  });
});